import { TreeNode } from 'primeng/api';
import { FilterTypes } from '../../../models/filterEnums.model';

export class FilterCriteria {
  title: string;
  type: FilterTypes;
  stepResults: number;
  searchResults: number;
  order: number;
  isActive = true;
  bvdId?: string;
  selectedCompanies?: any;
  selectedAbsoluteYr?: TreeNode[];

  validate(): boolean {
    return true;
  }

  copyInto(json: string): void {
    if (json !== undefined) {
      const parsedObject = JSON.parse(json);
      for (const key in parsedObject) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.hasOwnProperty(key)) {
          this[key] = parsedObject[key];
        }
      }
    }
  }

  toString(): string {
    return 'toString not implemented for Filter Type';
  }
}
